<script>
import axios from "axios";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";

export default {
    data() {
        return { informes: [], indice: 0, seccion: "resumen", cargando: false, exportando: false, error: "", paginaMatriz: 1,
            soloPendientes: false, asociando: false, seleccionAsociacion: null, autorizarAproximadas: false, mensajeAsociacion: "",
            secciones: [
                { id: "resumen", nombre: "1. Resumen / cursos" }, { id: "habilidades", nombre: "2. Habilidades" },
                { id: "contenidos", nombre: "3. Contenidos" }, { id: "preguntas", nombre: "4. Preguntas" },
                { id: "alumnos", nombre: "5. Estudiantes" }, { id: "matriz", nombre: "6. Tablero maestro" },
                { id: "conclusiones", nombre: "7. Revisión y conclusiones" },
            ] };
    },
    computed: {
        informe() { return this.informes[this.indice] || null; },
        hojasVisibles() { return this.informe ? this.informe.hojas.filter(h => !this.soloPendientes || !h.alumno || h.estado_asociacion === "asociada_aproximada") : []; },
        alumnosDisponibles() {
            if (!this.informe) return [];
            const usados = new Set(this.informe.hojas.filter(h => h.alumno).map(h => this.normalizarRut(h.alumno.rut)));
            return this.informe.alumnos_proveedor.filter(a => !usados.has(this.normalizarRut(a.rut)))
                .sort((a, b) => this.normalizarRut(a.rut).slice(0, -1).localeCompare(this.normalizarRut(b.rut).slice(0, -1), "es", { numeric: true }));
        },
        tablas() {
            const i = this.informe;
            if (!i) return [];
            const grupos = campo => i.grupos[campo].map(g => [g.nombre, g.preguntas, this.rango(g.proveedor), this.rango(g.nuestra)]);
            return [
                { id: "resumen", nombre: "Resumen del lote", columnas: ["Cursos disponibles", "Evaluación", "Preguntas", "Puntos", "Proveedor", "Nuestra lectura"],
                    filas: [[i.cursos.join(", "), i.actividades.join(", "), i.cantidad_preguntas, i.puntaje_total,
                        this.rango(i.promedio_proveedor), this.rango(i.promedio_nuestro)]] },
                { id: "habilidades", nombre: "Resultados por habilidad", columnas: ["Habilidad", "Preguntas", "Proveedor", "Nuestra lectura"], filas: grupos("Habilidad") },
                { id: "contenidos", nombre: "Resultados por contenido / eje", columnas: ["Eje", "Preguntas", "Proveedor", "Nuestra lectura"], filas: grupos("Eje") },
                { id: "preguntas", nombre: "Resultados por pregunta", columnas: ["Pregunta", "Clave", "Puntos", "Eje", "Habilidad", "Proveedor", "Nuestra lectura"],
                    filas: i.preguntas.map(p => [p.pregunta, p.correcta, p.puntaje, p.Eje, p.Habilidad, this.rango(p.proveedor), this.rango(p.nuestra)]) },
                { id: "alumnos", nombre: "Nuestras hojas y asociación con el proveedor",
                    columnas: ["Hoja", "RUT leído / tentativo", "Alumno asociado", "RUT asociado", "Puntos nuestros", "Logro nuestro", "Tramo", "Por revisar", "Coinciden / difieren / inciertas"],
                    filas: i.hojas.map(h => [h.nombre, h.rut || (h.rut_tentativo ? h.rut_tentativo + " (tentativo)" : "Sin lectura"),
                        h.alumno ? h.alumno.nombre + " · " + this.etiquetaAsociacion(h) : "Sin asociación",
                        h.alumno ? h.alumno.rut : "Sin asociar",
                        this.puntos(h.metricas), this.rango({ min: h.metricas.porcentaje_min, max: h.metricas.porcentaje_max }),
                        h.metricas.tramo || "Provisional", h.metricas.por_revisar,
                        h.comparacion ? `${h.comparacion.coincide} / ${h.comparacion.difiere} / ${h.comparacion.sin_lectura}` : "Sin comparar"]) },
                { id: "alumnos", nombre: "Resultados de alumnos entregados por el proveedor",
                    columnas: ["RUT", "Nombre", "Curso", "Puntos", "Logro", "Tramo"],
                    filas: i.alumnos_proveedor.map(a => [a.rut, a.nombre, a.curso, this.puntos(a.metricas),
                        this.rango({ min: a.metricas.porcentaje_min, max: a.metricas.porcentaje_max }), a.metricas.tramo]) },
                { id: "alumnos", nombre: "Nómina original del proveedor", columnas: ["RUT", "Nombre", "Curso", "Cumplimiento", "Puntos", "Total", "Tramo", "PAES M1 proveedor"],
                    filas: i.nomina.map(a => [a.Rut, `${a.Nombre} ${a.Apellido}`, a.Curso, a.Cumplimiento, a["Puntaje Obtenido"],
                        a["Puntaje Total"], a.Tramo, a["PAES M1"]]) },
                { id: "matriz", nombre: "Tablero maestro de respuestas", columnas: ["Hoja", "RUT asociado", "Asociación", "Pregunta", "Nuestra", "Estado", "Proveedor", "Comparación", "Clave", "Puntos"],
                    filas: i.matriz.map(m => [m.hoja, m.rut || "Sin asociar", m.rut ? this.etiquetaAsociacion(m) : "Sin asociar", m.pregunta,
                        m.estado_lectura === "por_revisar" ? "?" : (m.nuestra || "Omitida"), m.estado_lectura,
                        m.comparacion === "sin_asociar" ? "Sin asociar" : (m.proveedor || "Omitida"), m.comparacion, m.clave, m.puntaje]) },
            ];
        },
        visibles() {
            return this.tablas.filter(t => t.id === this.seccion).map(t => this.seccion === "matriz"
                ? { ...t, filas: t.filas.slice((this.paginaMatriz - 1) * 100, this.paginaMatriz * 100) } : t);
        },
        paginasMatriz() { return this.informe ? Math.max(1, Math.ceil(this.informe.matriz.length / 100)) : 1; },
        conclusiones() {
            const i = this.informe;
            if (!i) return [];
            return [
                `${i.cantidad_hojas} hojas cargadas; ${i.asociadas - (i.aproximadas || 0)} con asociación exacta o manual, ${i.aproximadas || 0} aproximadas por revisar y ${i.cantidad_hojas - i.asociadas} sin asociación.`,
                `El proveedor incluye ${i.cantidad_proveedor} alumnos con respuestas y ${i.cantidad_nomina} estudiantes en la nómina.`,
                `El logro se calcula sobre ${i.puntaje_total} puntos, no sobre las ${i.cantidad_preguntas} preguntas; las de ponderación cero no suman puntaje.`,
                "Los rangos indican mínimo confirmado y máximo posible. Una lectura dudosa no se cuenta como incorrecta ni como omitida.",
                "Las asociaciones aproximadas permiten comparar provisionalmente; el porcentaje mide similitud del RUT, no probabilidad de identidad. Requieren revisión humana.",
                "Las lecturas y sus tramos son referenciales y requieren revisión humana; no habilitan calificación automática.",
                "Solo se muestran los cursos disponibles en este Excel. No se inventa información de otros cursos, objetivos o unidades ausentes.",
                "El puntaje PAES del proveedor se conserva en su nómina. No se calcula uno propio sin la tabla de conversión correspondiente.",
                i.rut_duplicados.length ? `Atención: ${i.rut_duplicados.length} RUT tienen más de una hoja asociada; revisar duplicados antes de concluir.` : "No se detectaron RUT asociados a varias hojas.",
                "Plan de revisión: confirmar primero los RUT pendientes, revisar marcas dudosas y después analizar las diferencias entre lectores.",
            ];
        },
    },
    mounted() { this.cargar(); },
    methods: {
        normalizarRut(rut) { return rut.replace(/[\s.\-]/g, "").toUpperCase(); },
        etiquetaAsociacion(hoja) {
            return hoja.estado_asociacion === "asociada_aproximada" ? `Aproximada · ${this.numero(hoja.similitud)}% de similitud · por revisar` :
                (hoja.estado_asociacion === "asociada_manualmente" ? "Confirmación manual" : "RUT seguro");
        },
        opcionesAlumno(hoja) {
            return (hoja.estado_asociacion === "asociada_aproximada" ? [hoja.alumno, ...this.alumnosDisponibles] : this.alumnosDisponibles)
                .slice().sort((a, b) => this.normalizarRut(a.rut).slice(0, -1).localeCompare(this.normalizarRut(b.rut).slice(0, -1), "es", { numeric: true }));
        },
        async asociarAproximadas() {
            if (!this.informe || !this.autorizarAproximadas || this.asociando || this.cargando) return;
            this.asociando = true;
            this.error = "";
            this.mensajeAsociacion = "";
            try {
                const response = await axios.post("/api/escaneos-respuestas/asociar-aproximadas", {
                    sha256: this.informe.sha256, autorizar_aproximadas: true,
                });
                this.mensajeAsociacion = response.data.mensaje;
                this.autorizarAproximadas = false;
                await this.cargar();
            } catch (error) {
                this.error = error.response && error.response.data && (error.response.data.mensaje || error.response.data.message) ||
                    "No se pudo completar la asociación aproximada. Actualiza el informe para revisar lo guardado.";
            } finally { this.asociando = false; }
        },
        elegirAlumno(hoja, rut) {
            this.seleccionAsociacion = rut ? { hoja: hoja.id, rut, confirmado: false } : null;
        },
        async asociar(hoja) {
            const seleccion = this.seleccionAsociacion;
            if (this.asociando || this.cargando || !seleccion || seleccion.hoja !== hoja.id || !seleccion.confirmado ||
                !this.opcionesAlumno(hoja).some(a => this.normalizarRut(a.rut) === this.normalizarRut(seleccion.rut))) return;
            this.asociando = true;
            this.error = "";
            try {
                const response = await axios.post(`/api/escaneos-respuestas/${hoja.id}/asociar-proveedor`, {
                    rut: seleccion.rut, confirmar_identidad: true,
                });
                const comparacion = response.data.comparacion_proveedor;
                this.$set(hoja, "alumno", comparacion.alumno);
                this.$set(hoja, "estado_asociacion", comparacion.estado);
                this.$set(hoja, "comparacion", comparacion.resumen);
                this.seleccionAsociacion = null;
                this.autorizarAproximadas = false;
                await this.cargar();
            } catch (error) {
                this.error = error.response && error.response.data && (error.response.data.mensaje || error.response.data.message) ||
                    "No se pudo confirmar la asociación. Actualiza el informe antes de reintentar.";
            } finally { this.asociando = false; }
        },
        async cargar() {
            if (this.cargando) return;
            this.cargando = true;
            this.error = "";
            try {
                const r = await axios.get("/api/escaneos-respuestas/informe");
                this.informes = r.data.informes;
                this.indice = Math.min(this.indice, Math.max(0, this.informes.length - 1));
                this.paginaMatriz = 1;
                this.seleccionAsociacion = null;
            } catch (error) {
                this.error = error.response && error.response.data && (error.response.data.mensaje || error.response.data.message) ||
                    "No se pudo cargar el informe comparativo.";
            } finally { this.cargando = false; }
        },
        numero(valor) { return Number.isFinite(valor) ? valor.toLocaleString("es-CL", { maximumFractionDigits: 1 }) : "Sin datos"; },
        rango(valor) {
            if (!valor || !Number.isFinite(valor.min) || !Number.isFinite(valor.max)) return "Sin datos";
            return Math.abs(valor.min - valor.max) < 0.000001 ? `${this.numero(valor.min)}%` :
                `${this.numero(valor.min)}% a ${this.numero(valor.max)}% (provisional)`;
        },
        puntos(m) { return m.puntos_min === m.puntos_max ? this.numero(m.puntos_min) : `${this.numero(m.puntos_min)} a ${this.numero(m.puntos_max)}`; },
        async excel() {
            if (!this.informe || this.exportando) return;
            this.exportando = true;
            this.error = "";
            try {
                const libro = XLSX.utils.book_new();
                this.tablas.forEach((t, indice) => XLSX.utils.book_append_sheet(libro,
                    XLSX.utils.aoa_to_sheet([t.columnas, ...t.filas]), `${indice + 1} ${t.nombre}`.replace(/[\\\/:?*\[\]]/g, " ").slice(0, 31)));
                XLSX.utils.book_append_sheet(libro, XLSX.utils.aoa_to_sheet([["Observaciones"], ...this.conclusiones.map(c => [c])]), "Revision");
                XLSX.writeFile(libro, "informe-comparativo-respuestas.xlsx");
            } catch (error) {
                console.error("No se pudo exportar el informe Excel", error);
                this.error = "No se pudo generar el Excel comparativo.";
            } finally { this.exportando = false; }
        },
        async pdf() {
            if (!this.informe || this.exportando) return;
            this.exportando = true;
            this.error = "";
            try {
                const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
                let y = 15;
                const escribir = (texto, tamano = 9) => {
                    doc.setFontSize(tamano);
                    const lineas = doc.splitTextToSize(String(texto), 267);
                    for (const linea of lineas) {
                        if (y > 193) { doc.addPage(); y = 15; }
                        doc.text(linea, 15, y);
                        y += tamano === 13 ? 7 : 5;
                    }
                };
                escribir("Informe comparativo de hojas de respuestas", 13);
                escribir(`${this.informe.actividades.join(", ")} | ${this.informe.cursos.join(", ")} | Generado: ${this.informe.generado_en}`);
                this.conclusiones.forEach(c => escribir(c));
                for (const tabla of this.tablas) {
                    doc.addPage(); y = 15;
                    escribir(tabla.nombre, 13);
                    escribir(tabla.columnas.join(" | "));
                    tabla.filas.forEach(fila => escribir(fila.map(v => v == null ? "Sin dato" : v).join(" | ")));
                }
                doc.save("informe-comparativo-respuestas.pdf");
            } catch (error) {
                console.error("No se pudo exportar el informe PDF", error);
                this.error = "No se pudo generar el PDF comparativo.";
            } finally { this.exportando = false; }
        },
    },
};
</script>

<template>
    <section class="informe-respuestas">
        <div class="d-flex flex-wrap align-items-center mb-3">
            <h2 class="mr-auto">Informe comparativo</h2>
            <button class="btn btn-light mr-2" :disabled="cargando || exportando || asociando" @click="cargar">Actualizar</button>
            <button class="btn btn-outline-primary mr-2" :disabled="!informe || exportando || cargando || asociando" @click="excel">Descargar Excel</button>
            <button class="btn btn-outline-primary" :disabled="!informe || exportando || cargando || asociando" @click="pdf">Descargar PDF</button>
        </div>
        <p v-if="error" class="alert alert-danger" role="alert">{{ error }}</p>
        <p v-if="cargando" role="status">Generando informe...</p>
        <p v-else-if="!informes.length">Aún no hay lotes con informe de proveedor.</p>
        <template v-if="informe">
            <label for="lote-informe">Informe de proveedor</label>
            <select id="lote-informe" v-model.number="indice" class="form-control mb-3" :disabled="asociando || cargando"
                @change="paginaMatriz = 1; seleccionAsociacion = null; autorizarAproximadas = false; mensajeAsociacion = ''">
                <option v-for="(item, n) in informes" :key="item.sha256" :value="n">{{ item.archivo }} · {{ item.cursos.join(', ') }}</option>
            </select>
            <div class="alert alert-warning">
                {{ informe.asociadas - (informe.aproximadas || 0) }} de {{ informe.cantidad_hojas }} hojas con asociación exacta o manual;
                {{ informe.aproximadas || 0 }} aproximadas por revisar.
                Los rangos son provisionales: no confundir lectura incierta con respuesta incorrecta.
            </div>
            <nav class="nav nav-pills mb-3" aria-label="Secciones del informe">
                <button v-for="item in secciones" :key="item.id" class="nav-link btn" :class="{ active: seccion === item.id }"
                    :aria-pressed="seccion === item.id" @click="seccion = item.id">{{ item.nombre }}</button>
            </nav>
            <template v-if="seccion === 'conclusiones'">
                <h3>Conclusiones y plan de revisión</h3><ul><li v-for="texto in conclusiones" :key="texto">{{ texto }}</li></ul>
            </template>
            <section v-if="seccion === 'alumnos'" class="mb-4">
                <h3>Nuestras hojas y asociación con el proveedor</h3>
                <label><input v-model="soloPendientes" type="checkbox" /> Mostrar solo hojas pendientes de asociación o revisión</label>
                <p>{{ alumnosDisponibles.length }} alumnos del proveedor sin asociar. Confirma la identidad revisando el RUT de la imagen, no el orden de las hojas.</p>
                <div class="alert alert-warning">
                    <label><input v-model="autorizarAproximadas" type="checkbox" :disabled="asociando || cargando" />
                        Autorizar asociaciones provisionales con al menos 80% de similitud del RUT, candidato único y sin competencia entre hojas.</label>
                    <p>Los dígitos distintos y «?» no coinciden. La similitud no es probabilidad de identidad. No se reemplazan asociaciones existentes.</p>
                    <button class="btn btn-outline-primary btn-sm" :disabled="!autorizarAproximadas || asociando || cargando" @click="asociarAproximadas">Asociar pendientes por similitud</button>
                </div>
                <p v-if="mensajeAsociacion" role="status">{{ mensajeAsociacion }}</p>
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead><tr><th>Hoja</th><th>RUT leído / tentativo</th><th>Alumno asociado</th><th>RUT asociado</th><th>Puntos nuestros</th><th>Logro nuestro</th><th>Tramo</th><th>Por revisar</th><th>Coinciden / difieren / inciertas</th><th>Asociar alumno pendiente</th></tr></thead>
                        <tbody><tr v-for="hoja in hojasVisibles" :key="hoja.id">
                            <td><button class="btn btn-outline-secondary btn-sm" :disabled="asociando" @click="$emit('revisar', hoja)">{{ hoja.nombre }}</button></td>
                            <td>{{ hoja.rut || (hoja.rut_tentativo ? hoja.rut_tentativo + ' (tentativo)' : 'Sin lectura') }}</td>
                            <td>{{ hoja.alumno ? hoja.alumno.nombre : 'Sin asociación confirmada' }}
                                <span v-if="hoja.alumno"> · {{ etiquetaAsociacion(hoja) }}</span></td>
                            <td>{{ hoja.alumno ? hoja.alumno.rut : 'Sin asociar' }}</td>
                            <td>{{ puntos(hoja.metricas) }}</td>
                            <td>{{ rango({ min: hoja.metricas.porcentaje_min, max: hoja.metricas.porcentaje_max }) }}</td>
                            <td>{{ hoja.metricas.tramo || 'Provisional' }}</td>
                            <td>{{ hoja.metricas.por_revisar }}</td>
                            <td>{{ hoja.comparacion ? `${hoja.comparacion.coincide} / ${hoja.comparacion.difiere} / ${hoja.comparacion.sin_lectura}` : 'Sin comparar' }}</td>
                            <td>
                                <template v-if="!hoja.alumno || hoja.estado_asociacion === 'asociada_aproximada'">
                                    <select class="form-control form-control-sm" :aria-label="'Alumno para ' + hoja.nombre"
                                        :disabled="asociando || cargando || !opcionesAlumno(hoja).length"
                                        :value="seleccionAsociacion && seleccionAsociacion.hoja === hoja.id ? seleccionAsociacion.rut : ''"
                                        @change="elegirAlumno(hoja, $event.target.value)">
                                        <option value="">Selecciona nombre y RUT</option>
                                        <option v-for="alumno in opcionesAlumno(hoja)" :key="alumno.rut" :value="alumno.rut">{{ alumno.nombre }} · {{ alumno.rut }}</option>
                                    </select>
                                    <template v-if="seleccionAsociacion && seleccionAsociacion.hoja === hoja.id">
                                        <label><input v-model="seleccionAsociacion.confirmado" type="checkbox" :disabled="asociando || cargando" /> Revisé el RUT en la imagen y confirmo la identidad.</label>
                                        <button class="btn btn-outline-primary btn-sm" :disabled="asociando || cargando || !seleccionAsociacion.confirmado" @click="asociar(hoja)">{{ asociando ? 'Guardando...' : 'Confirmar asociación' }}</button>
                                    </template>
                                </template>
                                <span v-else>Asociación confirmada</span>
                            </td>
                        </tr><tr v-if="!hojasVisibles.length"><td colspan="10">No hay hojas pendientes de asociación.</td></tr></tbody>
                    </table>
                </div>
            </section>
            <section v-for="tabla in visibles" :key="tabla.nombre" class="mb-4">
                <template v-if="tabla.nombre !== 'Nuestras hojas y asociación con el proveedor'">
                <h3>{{ tabla.nombre }}</h3>
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <caption class="sr-only">{{ tabla.nombre }}</caption>
                        <thead><tr><th v-for="columna in tabla.columnas" :key="columna" scope="col">{{ columna }}</th></tr></thead>
                        <tbody><tr v-for="(fila, n) in tabla.filas" :key="n">
                            <td v-for="(valor, c) in fila" :key="c">{{ valor == null ? 'Sin dato' : valor }}</td>
                        </tr></tbody>
                    </table>
                </div>
                </template>
            </section>
            <div v-if="seccion === 'matriz'" class="d-flex align-items-center">
                <button class="btn btn-light" :disabled="paginaMatriz <= 1" @click="paginaMatriz--">Anterior</button>
                <span class="mx-3">Página {{ paginaMatriz }} de {{ paginasMatriz }} · 100 filas por página</span>
                <button class="btn btn-light" :disabled="paginaMatriz >= paginasMatriz" @click="paginaMatriz++">Siguiente</button>
            </div>
        </template>
    </section>
</template>

<style scoped>
.informe-respuestas { min-width: 0; }
.informe-respuestas h3 { font-size: 16px; }
.informe-respuestas th, .informe-respuestas td { min-width: 85px; font-size: 12px; vertical-align: middle; }
.informe-respuestas .nav-link { font-size: 12px; margin: 0 4px 4px 0; }
.informe-respuestas li { margin-bottom: 8px; }
</style>
